import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import DBKButton from '@dbk/ui-buttons';
import { FormGroup, TextInput, Message, Label } from '@dbk/ui-forms';
import WizardSteps from '@dbk/ui-wizard-steps';
import ProgressBar from '@dbk/ui-progress-bar';

import Text, { H3, Small } from '../../../components/common//text';
import Button from '../../../components/common/button';
import { ValidationLabel } from '../../../components/common/validation';
import {
  emptyError,
  noMatchError,
  minimumCharsError,
  upperCaseError,
  lowerCaseError,
  specialCharsError,
} from '../../../components/common/validation/validation-utils';
import styles from './change-password-from-login.styles';
import commonStyle from '../../../screens/user/login/login.common.style';
import encryptionHtmlAndScriptIE from '../dbsecurelogin/webviewencryptionscriptIE';
import { LoadingCircle } from '../../../components/common/loading';
import BlurModal from '../../../components/common/blur-modal';

const passwordMinimumChars = 8;

class ChangePasswordFromLogin extends PureComponent {
  constructor(props) {
    super(props);

    this.newCryptoPassword = undefined;
    this.state = {
      isSecureTextEntry: true,
      newPassword: '',
      newPasswordEmptyText: '',
      confirmPassword: '',
      passwordErrorText: '',
      newPasswordEmpty: undefined,
      confirmPasswordError: undefined,
      noMinimumChars: undefined,
      noUpperCase: undefined,
      noLowerCase: undefined,
      noSpecialChars: undefined,
      noSamePassword: undefined,
      progress: 0,
      passwordStrength: 'None',
      changePasswordModal: true,
    };

    // Submit
    this.handleChangePassword = this.handleChangePassword.bind(this);

    // Input value change
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
    this.passwordStrength = this.passwordStrength.bind(this);
    this.hideChangePassword = this.hideChangePassword.bind(this);
    this.doChangePasswordIE = this.doChangePasswordIE.bind(this);

    const userId = this.props.auth.userId;
    const type = 'changePassword';
    if (userId !== undefined) {
      this.props.auth.globalAuthEncryptionKey({ userId, type });
    }
  }

  componentDidUpdate(_, prevState) {
    if (prevState.newPassword !== this.state.newPassword ||
      prevState.confirmPassword !== this.state.confirmPassword) {
      this.validate();
    }
    if (this.props.resetcode.resetPasswordSuccess === true) {
      const { i18n: { messages } } = this.props;
      const successDescription = messages['app.reset.changePassword.successDescription'];
      alert(successDescription);
      this.hideChangePassword();
    }
  }

  hideChangePassword() {
    this.setState({ changePasswordModal: false });
    this.props.resetcode.resetResetCodeVariables();
    setTimeout(() => { window.location.reload(); }, 500);
  }

  getSamePasswordText(newPasswordEmpty) {
    const { i18n: { messages } } = this.props;

    if (newPasswordEmpty) {
      return {
        error: true,
        text: messages['app.auth.newPassword.errorText'],
      };
    }

    return {
      error: false,
      text: '',
    };
  }

  getPasswordErrorText({ confirmPasswordEmpty, noMatch }) {
    const { i18n: { messages } } = this.props;

    if (confirmPasswordEmpty) {
      return {
        error: true,
        text: messages['app.auth.confirmPassword.errorText'],
      };
    }

    if (noMatch) {
      return {
        error: true,
        text: messages['app.auth.noMatchPassword.errorText'],
      };
    }

    return {
      error: noMatch === false ? false : confirmPasswordEmpty,
      text: '',
    };
  }

  validate() {
    const { newPassword, confirmPassword } = this.state;

    const newPasswordEmpty = emptyError(newPassword, false);
    const confirmPasswordEmpty = emptyError(confirmPassword, false);
    const noMatch = noMatchError(newPassword, confirmPassword);
    const noMinimumChars = minimumCharsError(newPassword, passwordMinimumChars);
    const noUpperCase = upperCaseError(newPassword);
    const nolowerCase = lowerCaseError(newPassword);
    const noSpecialChars = specialCharsError(newPassword);
    const samePassword = this.getSamePasswordText(newPasswordEmpty);
    this.passwordStrength(newPassword);
    const passwordError = this.getPasswordErrorText({
      confirmPasswordEmpty,
      noMatch,
    });

    const valid = !newPasswordEmpty
      && !confirmPasswordEmpty
      && !noMatch
      && !noMinimumChars
      && !noUpperCase
      && !nolowerCase
      && !noSpecialChars;

    this.setState({
      noMinimumChars,
      noUpperCase,
      noSpecialChars,
      nolowerCase,
      newPasswordEmpty: samePassword.error,
      newPasswordEmptyText: samePassword.text,
      confirmPasswordError: passwordError.error,
      passwordErrorText: passwordError.text,
    });

    return valid;
  }

  togglePasswordValue() {
    this.setState({
      isSecureTextEntry: !this.state.isSecureTextEntry,
    });
  }

  handleNewPasswordChange(e) {
    const value = e.target.value;
    const newvalue = value.replace(/^\s+|\s+$/g, '');
    this.setState({ newPassword: newvalue });
  }

  handleConfirmPasswordChange(e) {
    const value = e.target.value;
    const newvalue = value.replace(/^\s+|\s+$/g, '');
    this.setState({ confirmPassword: newvalue });
  }

  handleChangePassword() {
    if (this.validate()) {
      this.props.auth.setChangePasswordBusy(true);
      this.doChangePasswordIE();
    }
  }

  onBridgeMessage(message) {
    const defaultMessage = 'Inside onBridgeMessage message is ';
    console.log(defaultMessage + message.nativeEvent.data);
    this.newCryptoPassword = message.nativeEvent.data;
  }

  doChangePasswordIE() {
    const { newPassword } = this.state;
    let globalAuth = this.props.auth;
    const { token, modulus, exponent } = globalAuth.cryptoEncryptedObj;
    const cryptoEncryptionRequestParamNewPWD = {
      password: newPassword,
      modulus: modulus,
      exponent: exponent,
      token: token,
    };
    const { resetcode: { changePassword } } = this.props;

    const promiseEncryption = encryptionHtmlAndScriptIE(JSON.stringify(cryptoEncryptionRequestParamNewPWD), function (encryptedData) {
      console.log('encryptedData after encryption in doChangePasswordIE New is ' + encryptedData);
      const newCrypto = encryptedData;

      if (newCrypto === 'ERROR') {
        globalAuth.setErrorMsg('Unable to connect. Please try again later.');
        globalAuth.setChangePasswordBusy(false);
      } else {
        changePassword(token, newCrypto);
      }
    });
  }


  passwordStrength(password) {
    const { i18n: { messages } } = this.props;
    const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    const mediumRegex = new RegExp('^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})');
    if (strongRegex.test(password)) {
      this.setState({
        passwordStrength: messages['app.reset.changePassword.strong'],
        progress: 100,
      });
    } else if (mediumRegex.test(password)) {
      this.setState({
        passwordStrength: messages['app.reset.changePassword.medium'],
        progress: 50,
      });
    } else if (password !== '') {
      this.setState({
        passwordStrength: messages['app.reset.changePassword.weak'],
        progress: 25,
      });
    } else {
      this.setState({
        passwordStrength: messages['app.reset.changePassword.none'],
        progress: 0,
      });
    }
  }

  render() {
    const {
      isSecureTextEntry,
      newPassword,
      newPasswordEmptyText,
      confirmPassword,
      newPasswordEmpty,
      confirmPasswordError,
      noUpperCase,
      nolowerCase,
      noMinimumChars,
      noSpecialChars,
      passwordErrorText,
      passwordStrength,
      changePasswordModal,
      progress
    } = this.state;

    const { i18n: { messages }, resetcode: { resetPasswordBusy, errorText } } = this.props;
    const errorTextPrompt = this.props.resetcode.errorText;
    const secureTextEntryText = isSecureTextEntry
      ? messages['app.auth.showPassword']
      : messages['app.auth.hidePassword'];
    const strengthString = messages['app.reset.changePassword.strength'];
    const textInputType = isSecureTextEntry ? 'password' : 'text';
    const nativeStyle = commonStyle;
    const formGroupMargin = !newPasswordEmpty ?
      nativeStyle.formGroup : nativeStyle.formGroupErrorMargin;
    const formGroupLastMargin = nativeStyle.formGroupErrorLastMargin;
    return (
      <BlurModal
        onDone={this.hideChangePassword}
        visible={changePasswordModal}
        doneLabel={messages['app.common.closeText']}
        type="xdark"
        headerChildren={
          <Text style={{ color: 'white', textAlign: 'center' }}>
            {messages['app.reset.forgotPassword.title']}
          </Text>
        }
      >
        <div className="scene">
          <div className="row change-password">
            <div className="columns small-12 medium-12 text-center">
              <div className="module changePasswordAlign margin-left-20">
                <div className="row">
                  <View style={StyleSheet.flatten(styles.breadcrumbsContainer)}>
                    <WizardSteps useEqualSpacing steps={[
                      { label: messages['app.reset.breadcrumbs.requestCode'] },
                      { label: messages['app.reset.breadcrumbs.enterCode'] },
                      { label: messages['app.reset.breadcrumbs.resetNewPassword'] },
                    ]}
                      currentStepIndex={2}
                    />
                  </View>
                </div>
                <div className="pad-top-20">
                  <H3 className="pad-bottom-10 text-center">
                    {messages['app.reset.changePassword.title']}
                  </H3>
                </div>
                <div>
                  <Text className="pad-top-10 pad-bottom-10">
                    {messages['app.auth.newPassword.errorText']}
                  </Text>
                </div>
                <div className="row">
                  <View className="LoginForm text-left">
                    <FormGroup style={formGroupMargin}>
                      <Label style={StyleSheet.flatten(nativeStyle.labelStyle)}>{messages['app.auth.newPassword']}</Label>
                      <View className='form__input-wrapper' style={StyleSheet.flatten(nativeStyle.inputWrapper)}>
                        <TextInput
                          style={StyleSheet.flatten(nativeStyle.input)}
                          textID="input-newpassword"
                          name="new-password"
                          value={newPassword}
                          placeholder={messages['app.auth.newPassword']}
                          type={textInputType}
                          secureTextEntry={isSecureTextEntry}
                          onChange={this.handleNewPasswordChange}
                          autoCorrect={false}
                          zIndex={-1}
                        />
                      </View>
                      {newPasswordEmpty && (
                        <Message style={StyleSheet.flatten(nativeStyle.userError)} type="error">
                          {newPasswordEmptyText}
                        </Message>
                      )}

                      {errorTextPrompt && (
                        <Message style={StyleSheet.flatten(nativeStyle.userError)} type="error">
                          {errorTextPrompt}
                        </Message>
                      )}

                    </FormGroup>
                    <FormGroup style={formGroupLastMargin} className="pad-top-20">
                      <Label style={StyleSheet.flatten(nativeStyle.labelStyle)}>{messages['app.auth.confirmPassword']}</Label>
                      <View className='form__input-wrapper' style={StyleSheet.flatten(nativeStyle.inputWrapper)}>
                        <TextInput
                          style={StyleSheet.flatten(nativeStyle.input)}
                          textID="input-newpassword"
                          name="new-password"
                          value={confirmPassword}
                          placeholder={messages['app.auth.confirmPassword']}
                          type={textInputType}
                          secureTextEntry={isSecureTextEntry}
                          onChange={this.handleConfirmPasswordChange}
                          autoCorrect={false}
                          zIndex={-1}
                        />
                      </View>
                      {confirmPasswordError && (
                        <Message style={StyleSheet.flatten(nativeStyle.userError)} type="error">
                          {passwordErrorText}
                        </Message>
                      )}
                    </FormGroup>
                  </View>
                  <View style={StyleSheet.flatten(styles.support)}>
                    <Button
                      inline
                      title={secureTextEntryText}
                      onPress={() => this.togglePasswordValue()}
                    />
                  </View>
                  <View style={StyleSheet.flatten(styles.validationLabels)}>
                    <ValidationLabel
                      style={StyleSheet.flatten(styles.validationLabel)}
                      title={messages['app.auth.validation.minimumChars']}
                      error={noMinimumChars}
                    />
                    <ValidationLabel
                      style={StyleSheet.flatten(styles.validationLabel)}
                      title={messages['app.auth.validation.upperCase']}
                      error={noUpperCase}
                    />
                    <ValidationLabel
                      style={StyleSheet.flatten(styles.validationLabel)}
                      title={messages['app.auth.validation.lowerCase']}
                      error={nolowerCase}
                    />
                    <ValidationLabel
                      style={StyleSheet.flatten(styles.validationLabel)}
                      title={messages['app.auth.validation.specialChars']}
                      error={noSpecialChars}
                    />
                    <View className="text-left">
                      <div className="pad-top-20 pad-bottom-20">
                        <H3 className="font-bold">{strengthString + passwordStrength}</H3>
                        {progress === 100 && <ProgressBar value={progress} success />}
                        {progress === 50 && <ProgressBar value={progress} warning />}
                        {progress === 25 && <ProgressBar value={progress} />}
                        {progress === 0 && <ProgressBar value={progress} error />}
                      </div>

                      <Small type="secondary" className="font-bold">
                        {messages['app.reset.changePassword.strengthNote']}
                      </Small>
                    </View>
                  </View>

                  {resetPasswordBusy === false &&
                    <DBKButton
                      fullWidth
                      size='large'
                      loading={resetPasswordBusy}
                      onPress={this.handleChangePassword}
                    >
                      {messages['app.reset.changePassword.title']}
                    </DBKButton>
                  }
                  {resetPasswordBusy === true &&
                    <LoadingCircle />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurModal>
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      changePasswordErrorMessage: true,
      changePasswordBusy: true,
      onChangePasswordinProfilePage: { $call: 'changePasswordinProfilePage' },
      cryptoEncryptedObj: true,
      globalAuthEncryptionKey: { $call: 'getGlobalAuthEncryptionKey' },
      cryptoEncryptedObjSuccess: true,
      setCryptoEncryptedObjSuccess: { $set: 'cryptoEncryptedObjSuccess' },
      userId: true,
      setChangePasswordBusy: { $set: 'changePasswordBusy' },
      setErrorMsg: { $set: 'changePasswordErrorMessage' },
      logout: { $call: 'logout' },
    },
    i18n: {
      messages: true,
    },
    resetcode: {
      changePassword: { $call: 'changePassword' },
      resetPasswordBusy: true,
      setResetPasswordBusy: { $set: 'resetPasswordBusy' },
      resetPasswordSuccess: true,
      resetResetCodeVariables: { $call: 'resetVariables' },
      errorText: true,
    },
  },
})(ChangePasswordFromLogin);
